import { useEffect, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";

import { useAuthentication } from "@app/store/useAuthtentication";
import { usePermissions } from "@app/common/hooks/usePermissions";
import { warningNotification } from "@app/common/components/notifications";
import { getRoutePermission } from "./routePermissions";

interface RoutePermissionGuardProps {
  children: ReactNode;
  routePath: string;
  fallbackPath?: string;
}

const RoutePermissionGuard = ({
  children,
  routePath,
  fallbackPath = "/dispensation"
}: RoutePermissionGuardProps) => {
  const navigate = useNavigate();
  const allCategories = useAuthentication((state) => state.auth.allCategory.all_Categories);
  const { can } = usePermissions();

  const { prefix: requiredPrefix, action: requiredAction } = getRoutePermission({
    pathname: routePath,
    categories: allCategories
  });

  const canAccessRoute = !requiredPrefix || can(requiredAction, requiredPrefix);

  useEffect(() => {
    if (!canAccessRoute) {
      warningNotification(
        "No tiene permiso para ingresar a esta sección",
        "Intenta de nuevo"
      ).finally(() => {
        navigate(fallbackPath);
      });
    }
  }, [canAccessRoute, fallbackPath, navigate]);

  if (!canAccessRoute) {
    return null;
  }

  return <>{children}</>;
};

export default RoutePermissionGuard;
